export default Object.freeze({
  listContainer: 'ul',
  listItem: 'li',
  link: '.ws-link',
  icon: 'ws-icon',
  textItem: 'span',
  subListContainer: '.ws-footer-sublist',
});
